export const capabilityGroupsEndpoint = state => `${state.config.apiUrl}/v1/capability/groups`;

export const createCapabilityGroupEndpoint = state => `${state.config.apiUrl}/v1/capability/group`;

export const updateCapabilityGroupEndpoint = (state, payload) => (
    `${state.config.apiUrl}/v1/capability/group/${payload.capabilityGroupId}`
);
export const getCapabilityGroupEndpoint = (state, payload) => (
    `${state.config.apiUrl}/v1/capability/group/${payload.capabilityGroupId}`
);

export const deleteCapabilityGroupEndpoint = (state, payload) => (
    `${state.config.apiUrl}/v1/capability/group/${payload.capabilityGroupId}`
);



// WEBPACK FOOTER //
// ./src/services/capabilityGroups/selectors.js